import React, { Component } from "react";
import { connect } from "react-redux";
import { Link, withRouter } from "react-router-dom";
import { Image, RichText } from "@sitecore-jss/sitecore-jss-react";
import "./style.scss";
import SocailMedia from "../Social-Media";
import TrustSeals from "../../sections/trust-seals";
import BodyText from "../../elements/body-text";
import { gtag } from "../../utils";
import { normalizeHref } from "../../utils/siteUtils";
import { setShowRegionModal } from "../../redux/actions/actions";
import { scrollToSmoothTryMultipleTimes, scrollToSmoothTryMultipleTimesByDataSourceid } from "../../hooks/scrollToSmooth.js";

class Footer extends Component {
  constructor(props) {
    super(props);
    let selectedRegion = {};
    this.state = {
      footerItems_: this.props.fields ? this.props.fields.footerItems : [],
      selectedRegion: selectedRegion,
      notifacation: false
    };
  }

  componentDidUpdate(prevProps) {
    if (this.props.location.pathname !== prevProps.location.pathname) {
      window.scrollTo(0, 0);
    }
    const hash = this.props.location.hash;
    const cleanHash = hash
      ?.replace("#", "")
      ?.replace("{", "")
      ?.replace("}", "");

    const videos = document.querySelectorAll("video");
    const len = videos.length;
    let counter = 0;

    [].forEach.call(videos, function(video) {
      if (video.complete) {
        counter++;
        if (counter === len) {
          scrollToId(cleanHash);
        }
      } else {
        video.addEventListener(
          "loadeddata",
          () => {
            counter++;
            if (counter === len) {
              scrollToId(cleanHash);
            }
          },
          false
        );
      }
    });

    if (videos.length === 0) {
      scrollToId(cleanHash);
    }

    function scrollToId(cleanHash) {
      if (cleanHash && isUUID(cleanHash)) {
        scrollToSmoothTryMultipleTimesByDataSourceid(`{${cleanHash}}`);
      } else if (cleanHash) {
        scrollToSmoothTryMultipleTimes(cleanHash);
      }
    }

    function isUUID(uuid) {
      let s = "" + uuid;

      s = s.match("^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$");
      if (s === null) {
        return false;
      }
      return true;
    }
  }

  handleClick() {
    if (this.props.fields.RegionModel.value.href) {
      this.props.setShowRegionModal(true);
    }
  }
  toggle = (index, event) => {
    event.preventDefault();
    let newState = this.state.footerItems_;
    newState[index].fields.collapsed.value = !newState[index].fields.collapsed.value;
    this.setState({ footerItems_: newState });
  };
  render() {
    if (!this.props.fields) return null;
    let { fields } = this.props,
      { nofollowTextlink, socialItems, copyrightText, logo, paymentMethods, paymentMethodsTitle, notificationText, disclaimer } = fields,
      { footerItems_ } = this.state;

    const getPaymentMethodsImages = _paymentMethods => {
      if (_paymentMethods && _paymentMethods.length > 0) {
        let images = _paymentMethods.map(image => {
          return { url: image.fields.image.value.src };
        });
        return images;
      }
      return [];
    };

    const gtgaClick = (e, item) => {
      gtag('event', 'footer_clk', {
        'footer_name': normalizeHref(item?.fields?.link?.value?.href),
      });
    }

    const paymentMethodsImages = getPaymentMethodsImages(paymentMethods);
    return (
      <div className={"grid full-width footer"}>
        <section className={"mobile-top"}>
          {socialItems && socialItems.length > 0 && <SocailMedia fields={{ socialItems: socialItems }} />}
        </section>
        <section className={"footer-top"}>
          <div className="internal-links">
            {footerItems_.length > 0 &&
              footerItems_.map((item, index) => {
                return (
                  <div key={index | index}>
                    {/* <button className={` mobile-only ${item.fields.collapsed.value ? "plus" : "close"}`} onClick={evt => this.toggle(index, evt)} /> */}
                    {/*{item.fields.title && <RichText  tag="span" onClick={evt => this.toggle(index, evt)} className={"mobile-only"} field={item.fields.title}></RichText>}*/}
                    {/* <span onClick={evt => this.toggle(index, evt)} className={"mobile-only"}>
                      {item.fields.title.value}
                    </span>{" "} */}
                    {item.fields.title && <RichText tag="span" className={"desktop-only"} field={item.fields.title} />}
                    {item.fields.items != null &&
                      item.fields.items.map((subitem, subindex) => {
                        return (
                          <li key={subitem.id | subindex} className={`${item.fields.collapsed.value ? "hide" : ""}`} onClick={(e) => gtgaClick(e, subitem)}>
                            {subitem.fields.link.value && subitem.fields.link.value.linktype === "internal" && (
                              <Link to={normalizeHref(subitem.fields.link.value.href)} target={subitem.fields.link.value.target} hrefLang={this.props.lang} rel={nofollowTextlink.value ? "nofollow" : ""}>
                                {subitem.fields.link.value.text}
                                {subitem.fields.link.value.text.toLowerCase() === "press" && this.state.notifacation && notificationText && notificationText.value && <span className="notification">{notificationText.value}</span>}
                              </Link>
                            )}
                            {subitem.fields.link.value && subitem.fields.link.value.linktype === "external" && (
                              <a href={subitem.fields.link.value.href} target={subitem.fields.link.value.target} hrefLang={this.props.lang} rel={nofollowTextlink.value ? "nofollow" : ""}>
                                {subitem.fields.link.value.text}
                                {subitem.fields.link.value.text.toLowerCase() === "press" && this.state.notifacation && notificationText && notificationText.value && <span className="notification">{notificationText.value}</span>}
                              </a>
                            )}
                          </li>
                        );
                      })}
                  </div>
                );
              })}
          </div>
          <div className={"footer-top-right"}>
            {socialItems && socialItems.length > 0 && (
              <SocailMedia
                fields={{
                  socialItems: socialItems,
                  nofollowTextlink: nofollowTextlink
                }}
              />
            )}
            <div className="disclaimer">
              {disclaimer && <RichText tag="div" field={disclaimer} />}
            </div>
          </div>
        </section>

        {paymentMethods && paymentMethods.length !== 0 && (
          <section className={"payment-labels-mobile"}>
            <TrustSeals images={paymentMethodsImages} />
            <div className="payment-text">
              <BodyText html={paymentMethodsTitle.value} />
            </div>
          </section>
        )}

        <section className={"footer-tablet-section"}>
          {socialItems && socialItems.length > 0 && (
            <SocailMedia
              fields={{
                socialItems: socialItems,
                nofollowTextlink: nofollowTextlink
              }}
            />
          )}
        </section>
        <section className={"footer-disclaimer-section"}>
          <div className="disclaimer">
            {disclaimer && <RichText tag="div" field={disclaimer} />}
          </div>
        </section>
        <div className={"logo full-width footer-bottom"}>
          <div className="logo-container">
            <Image className="logo-svg" field={logo} />
            <div className="copyright-text">{copyrightText && <RichText tag="span" field={copyrightText} />}</div>
          </div>
          {paymentMethods && paymentMethods.length !== 0 && (
            <div className="payment-labels-desktop">
              <div className="payment-images">
                <TrustSeals images={paymentMethodsImages} />
              </div>
              <div className="payment-text">
                <BodyText html={paymentMethodsTitle.value} />
              </div>
            </div>
          )}
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  setShowRegionModal: data => dispatch(setShowRegionModal(data))
});

export default withRouter(connect(null, mapDispatchToProps)(Footer));
